export default function defineNuxtRouteMiddleware(to, from) {
  const host = ENV.currentConfig.domain[ENV.currentConfig.lang];
  useHead({
    link: [
      {
        rel: 'canonical',
        href: host + to.fullPath,
      },
    ],
  });
  if (import.meta.client) {
    localStorage.setItem("router-client", "1");
  }
  // const localePath = useLocalePath()

  // if (to.fullPath === '/') {
  //   return navigateTo({ path: "/images-photos/1" })
  // }

  // if (to.name.startsWith('images-photos-titletaskId')) {
  //   const params = to.params.title + to.params.taskId;
  //   const parts = params.split('-');
  //   const taskId = parts.pop();
  //   const title = parts.join('-');
  //   to.params.title = title;
  //   to.params.taskId = taskId;
  // }
  // if (to.path == "/test") {
  //   console.log("跳转到 /test 了,3秒后跳回首页");
  //   setTimeout(() => {
  //     return navigateTo({ path: "/", query: { id: 111 } });
  //   }, 3000);
  // }
}
